import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Project from '../Project'
import ProjectDetail from '../Project/Detail'
import ProjectCreate from '../Project/ProjectCreate'
import Gateway from "../Gateway";
import Cms from "../Cms";
import Permission from "../SystemSetting";
import User from "../SystemSetting/User";
import Org from "../SystemSetting/Org";
import GlobalDevices from "../SystemSetting/Devices";
import HistoryLogs from '../HistoryLogs'
import HistoryAlarms from '../HistoryLogs/alrams'
import Tasks from '../Tasks'
import Jobs from '../Jobs'
import Dashboard from '../Dashboard'
import ProjectDashboard from "../Dashboard/ProjectDashboard";
import Devices from '../Devices'
import Systemlogs from '../Systemlogs'
import GatewayDetail from "../Gateway/detail";
import AuthCheck from "../common/AuthCheck";
import UserProfile from "../UserProfile";
import Error from '../Error';
import HistoryProjects from "../HistoryLogs/projects";
import { ROLES } from "../../constants";
const {OBSERVER} = ROLES;


const HomePage = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/project', { replace: true })
    }, []);
    return null;
}

export const routes: any[] = [
    {
        path: "/",
        element: <HomePage />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        },
    },
    {
        path: "/me",
        element: <UserProfile />,
    },
    {
        path: "/project",
        element: <Project />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        },
    },
    {
        path: "/project/:projectId/*",
        element: <ProjectDetail />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        },
    },
    {
        path: "/project-create",
        element: <ProjectCreate />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        },
    },
    {
        path: "/gateway",
        element: <Gateway />,
        authControl: {
            rolesCanNotSee: [OBSERVER, ROLES.ELECTRICIAN, ROLES.REGIONAL_HEADER, ROLES.MANAGER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/cms",
        element: <Cms />,
        authControl: {
            rolesCanSee: [ROLES.ADMIN], // rolesCanNotSee 优先级更高
        }
    },
    {
        path: "/permission",
        element: <Permission />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        }
    },
    {
        path: "/system_user",
        element: <User />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.REGIONAL_HEADER, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/system_org",
        element: <Org />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.MANAGER, ROLES.REGIONAL_HEADER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/system_devices",
        element: <GlobalDevices />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.REGIONAL_HEADER, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/history-logs",
        element: <HistoryLogs />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/history-alarms",
        element: <HistoryAlarms />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/history-projects",
        element: <HistoryProjects />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/history-projects",
        element: <HistoryProjects />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, ROLES.MANAGER, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/history-projects/:projectId/*",
        element: <ProjectDetail isHistory />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        },
    },
    {
        path: "/tasks",
        element: <Tasks />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        }
    },
    {
        path: "/jobs",
        element: <Jobs />,
        authControl: {
            rolesCanSee: [ROLES.ADMIN], // rolesCanNotSee 优先级更高
        }
    },
    {
        path: "/dashboard",
        element: <Dashboard />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN], // rolesCanNotSee 优先级更高
        }
    },
    {
        path: "/dashboard/:projectId",
        element: <ProjectDashboard />,
    },
    {
        path: "/devices_global",
        element: <Devices />,
        authControl: {
            rolesCanNotSee: [OBSERVER],
        }
    },
    {
        path: "/system_logs",
        element: <Systemlogs />,
        authControl: {
            rolesCanSee: [ROLES.ADMIN], // rolesCanNotSee 优先级更高
          },
    },
    {
        path: "/gateway/:gatewayMac",
        element: <GatewayDetail />,
        authControl: {
            rolesCanNotSee: [ROLES.ELECTRICIAN, OBSERVER], // rolesCanNotSee 优先级更高
        },
    },
    {
        path: "/error",
        element: <Error />,
    },
].map((i: any) => {
    return {
        ...i,
        element: <AuthCheck authControl={i.authControl}>{i.element}</AuthCheck>
    }
})

export default () => <Routes>
    {
        routes.map(({ path, element }) => {
            return <Route key={path} element={element} path={path} />
        })
    }

</Routes>